import { ModelBase, observable } from "@shoothill/core";
import { action } from "mobx";
import { TypeDTOBase } from "Shared/DTOs/Shared";

export class TypeModelBase<TDto extends TypeDTOBase> extends ModelBase<TypeModelBase<TDto>, TDto> {
    @observable public id: string = "";
    @observable public name: string = "";
    @observable public normalizedName: string = "";
    @observable public type: number = 0;
    @observable public ordinal: number = 0;
    @observable public isDeleted: boolean = false;

    @action
    public fromDto = (dto: TDto | null | undefined): void => {
        if (!dto) return;
        this.id = dto.id;
        this.name = dto.name;
        this.normalizedName = dto.normalizedName;
        this.type = dto.type;
        this.ordinal = dto.ordinal;
        this.isDeleted = dto.isDeleted;
    };

    @action
    public toDto = (): TDto => {
        return {
            id: this.id,
            name: this.name,
            normalizedName: this.normalizedName,
            type: this.type,
            ordinal: this.ordinal,
            isDeleted: this.isDeleted,
        } as TDto;
    };

    @action
    public resetModel = (): void => {
        this.id = "";
        this.name = "";
        this.normalizedName = "";
        this.type = 0;
        this.ordinal = 0;
        this.isDeleted = false;
    };
}
